function getValidatorByType(type, validators) {
    return validators.find(validationObj => validationObj.type === type);
}
export { getValidatorByType };
